import { Wheat } from "lucide-react";
import { MARQUEE_ITEMS } from "@/constants/site";

export const Marquee = () => (
  <div
    data-testid="marquee"
    className="marquee relative overflow-hidden border-y border-arena/70 bg-crema/60 py-5"
    aria-label="Especialidades de la casa"
  >
    <div className="marquee-track flex w-max animate-marquee">
      {[0, 1].map((copia) => (
        <ul
          key={copia}
          aria-hidden={copia === 1}
          className="flex items-center gap-10 pr-10"
        >
          {MARQUEE_ITEMS.map((item, i) => (
            <li key={i} className="flex items-center gap-10 whitespace-nowrap">
              <span className="font-serif text-lg text-cafe">{item}</span>
              <Wheat className="h-4 w-4 text-chocolate/45" strokeWidth={1.6} />
            </li>
          ))}
        </ul>
      ))}
    </div>
  </div>
);

export default Marquee;
